/**
 * Setup application for use with Redux & React-Router
 *
 *
 * NOTE: 'react-router-apply-middleware' is not the same as
 * react-router/applyRouterMiddleware. Using that breaks relative links
 * TODO: in future, check to see if react-router one starts working and remove this dependency
 */

import PublicTokenPruner from './config/PublicTokenPruner.jsx'

// import primary libraries
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { HelmetProvider } from 'react-helmet-async'
import CookiesProvider from './providers/CookiesProvider.jsx'

console.log('React', React.version)

// instantiate tap event plugin
//injectTapEventPlugin();

// import scss files.
// NOTE: Webpack does NOT actually import these as js. Instead it will generate the yote.css file.
import './config/yote.scss'
import './theme/tailwind.css'

import routes from './config/routes.jsx'

import configureStore from './config/configureStore.js'
import { BrowserRouter } from 'react-router-dom'
import { CookieConsumerComponent } from './providers/CookieConsumerComponent.jsx'
import { ToastProvider } from './global/hooks/useToast.jsx'

// StrictMode double-invokes render and effects and warns on legacy APIs.
// Development builds only. import.meta.env.MODE is a compile-time constant that
// follows `vite --mode`, so the production bundle folds this to React.Fragment
// and carries no StrictMode at all. NOT import.meta.env.DEV: Vite reports that
// as false for every `vite build` regardless of --mode, and this repo has no
// dev server (see web/vite.config.js).
const Root =
  import.meta.env.MODE === 'development' ? React.StrictMode : React.Fragment

const store = configureStore()

// // listen to location changes and fire off a google analytics event.
// history.listen(function (location) {
//   console.log("GA location firing: " + location.pathname);
//   window.ga('send', 'pageview', location.pathname);
// });
createRoot(document.getElementById('application-main-yote')).render(
  <Root>
    <CookiesProvider
      clientID={window.brandingSettings.cookieYesClientId}
      blockUntilConsent={true}
    >
      <Provider store={store}>
        <HelmetProvider>
          <CookieConsumerComponent>
            <ToastProvider>
              <BrowserRouter>
                {routes}
                <PublicTokenPruner />
              </BrowserRouter>
            </ToastProvider>
          </CookieConsumerComponent>
        </HelmetProvider>
      </Provider>
    </CookiesProvider>
  </Root>,
)
